import React, { useState, useEffect, useContext } from "react";
import { useHistory } from "react-router-dom";
import AdminService from "../services/AdminService";
import Paper from "@material-ui/core/Paper";
import LocationCityIcon from "@material-ui/icons/LocationCity";
import EmailIcon from "@material-ui/icons/Mail";
import PhoneIcon from "@material-ui/icons/Phone";
import DeleteIcon from "@material-ui/icons/Delete";
import IconButton from "@material-ui/core/IconButton";
import PictureAsPdfIcon from "@material-ui/icons/PictureAsPdf";
import TextField from "@material-ui/core/TextField";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { AuthContext } from "../context/AuthContext";
import { ScreenSizeContext } from "../context/ScreenSizeContext";
import { useSnackbar } from "notistack";
import Button from "@material-ui/core/Button";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import PrintConsultantPage from "./printableComponents/PrintConsultantPage";
import "../styles/printStyles.css";
import getProfilePictureSource from "../genericFunctions/getProfilePictureSource";
import getUserFriendlyMessages from "../genericFunctions/getUserFriendlyMessages";
import { sortLanguagesByProficiency } from "../genericFunctions/languageProficiencies";
import { getProfileLanguageName } from "../genericFunctions/profileLanguages";
import {
  CREATED,
  REMOVED,
  UPDATED,
} from "../genericFunctions/operationTypeConstants";
import {
  PROFILEVERSIONS,
  ROLES,
  SKILLS,
  HOBBIES,
  LANGUAGES,
  EDUCATIONS,
  EXPERIENCES,
} from "../services/serviceConstants";
import PublicService from "../services/PublicService";
import Presentation from "./Presentation";
import Roles from "./Roles";
import Skills from "./Skills";
import Hobbies from "./Hobbies";
import Languages from "./Languages";
import Educations from "./Educations";
import Experiences from "./Experiences";

const VersionEditor = (props) => {
  const { id, versionId } = props.match.params;
  const history = useHistory();
  const authContext = useContext(AuthContext);
  const { onMobile } = useContext(ScreenSizeContext);
  const { enqueueSnackbar } = useSnackbar();
  const [message, setMessage] = useState(null);
  const [version, setVersion] = useState({
    name: "",
  });
  const [consultant, setConsultant] = useState({
    username: "",
  });
  const [managerInfo, setManagerInfo] = useState({
    username: "",
  });

  const [managerResume, setManagerResume] = useState(true);
  const [contactInfo, setContactInfo] = useState({ email: "", phone: "" });
  const [anonymousProfile, setAnonymousProfile] = useState(false);
  const [versionRoles, setVersionRoles] = useState([]);
  const [versionSkills, setVersionSkills] = useState([]);
  const [versionLanguages, setVersionLanguages] = useState([]);
  const [versionHobbies, setVersionHobbies] = useState([]);
  const [versionExperiences, setVersionExperiences] = useState([]);
  const [versionEducations, setVersionEducations] = useState([]);

  const printView = () => {
    const printableElements = document.getElementById("printme").innerHTML;
    const printHtml =
      "<html><head><title></title></head><body>" +
      printableElements +
      "</body></html>";
    const oldPage = document.body.innerHTML;
    document.body.innerHTML = printHtml;
    window.print();
    document.body.innerHTML = oldPage;
    window.location.reload();
  };

  const saveProfileVersion = (profileVersionToSave) => {
    AdminService.updateArrayItem(
      id,
      profileVersionToSave,
      PROFILEVERSIONS
    ).then((data) => {
      const { message } = data;
      if (!message.msgError) {
        setMessage(
          getUserFriendlyMessages(UPDATED, "consultant profile version")
        );
      } else if (message.msgBody === "Unauthorized") {
        setMessage(message);
        authContext.setUser({ username: "", role: "" });
        authContext.setIsAuthenticated(false);
      } else {
        setMessage(message);
      }
      updateConsultant();
    });
  };
  const onSubmit = (e) => {
    e.preventDefault();
    saveProfileVersion(version);
  };

  const deleteVersion = () => {
    AdminService.deleteArrayItem(id, versionId, PROFILEVERSIONS).then(
      (data) => {
        const { message } = data;
        if (!message.msgError) {
          setMessage(
            getUserFriendlyMessages(REMOVED, "consultant profile version")
          );
          history.push(`/versionmanager/${id}`);
        } else if (message.msgBody === "Unauthorized") {
          setMessage(message);
          authContext.setUser({ username: "", role: "" });
          authContext.setIsAuthenticated(false);
        } else {
          setMessage(message);
        }
      }
    );
  };

  const onChange = (e) => {
    setVersion({ ...version, [e.target.name]: e.target.value });
  };

  const changeManager = (e) => {
    if (e.target.name === "managerResume") {
      if (!managerResume) {
        setConsultant({
          ...consultant,
          email: managerInfo.email,
          phone: managerInfo.phone,
        });
      } else {
        setConsultant({
          ...consultant,
          email: contactInfo.email,
          phone: contactInfo.phone,
        });
      }
    }
  };
  const updateConsultant = () => {
    PublicService.getConsultant(id).then((data) => {
      if (data && data.user) {
        setConsultant(data.user);
        setAnonymousProfile(data.user.privateResume);
        if (data.user.profileVersions) {
          setVersion(
            data.user.profileVersions.find(
              (profileVersion) => profileVersion._id === versionId
            )
          );
        }
      }
    });
  };

  useEffect(() => {
    PublicService.getConsultant(id).then((data) => {
      if (data && data.user) {
        setConsultant(data.user);
        setAnonymousProfile(data.user.privateResume);
        if (data.user.profileVersions) {
          setVersion(
            data.user.profileVersions.find(
              (profileVersion) => profileVersion._id === versionId
            )
          );
        }
        setContactInfo({ email: data.user.email, phone: data.user.phone });
        if (data.user.manager) {
          PublicService.getConsultant(data.user.manager).then((managerData) => {
            if (managerData && managerData.user) {
              setManagerInfo(managerData.user);
            }
          });
        }
      }
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (version.roles) {
      const sortedData = [...version.roles].sort((a, b) => b.stars - a.stars);
      setVersionRoles(sortedData);
    }
    if (version.skills) {
      const sortedData = [...version.skills].sort((a, b) => b.stars - a.stars);
      setVersionSkills(sortedData);
    }
    if (version.languages) {
      setVersionLanguages(sortLanguagesByProficiency(version.languages));
    }
    if (version.hobbies) {
      setVersionHobbies(version.hobbies);
    }
    if (version.experiences) {
      setVersionExperiences(
        version.experiences.map((item) => {
          Object.assign(item, {
            fromDateFormatted:
              item.fromDate !== null ? item.fromDate.split("T")[0] : "",
            toDateFormatted:
              item.toDate !== null ? item.toDate.split("T")[0] : "2999-12-30",
          });
          return item;
        })
      );
    }
    if (version.educations) {
      setVersionEducations(
        version.educations.map((item) => {
          Object.assign(item, {
            fromDateFormatted:
              item.fromDate !== null ? item.fromDate.split("T")[0] : "",
            toDateFormatted:
              item.toDate !== null ? item.toDate.split("T")[0] : "2999-12-30",
          });
          return item;
        })
      );
    }
  }, [version]);

  useEffect(() => {
    if (message !== null) {
      enqueueSnackbar(message.msgBody, {
        variant: message.msgError ? "error" : "info",
      });
    }
    setTimeout(() => {
      setMessage(null);
    }, 3000);
  }, [message]); // eslint-disable-line react-hooks/exhaustive-deps

  const onSubmitPresentation = (e, presentation) => {
    e.preventDefault();
    saveProfileVersion({
      ...version,
      presentation: presentation.presentation,
    });
  };

  const displayMessage = (message, messageToDisplayOnSuccess) => {
    if (!message.msgError) {
      setMessage(messageToDisplayOnSuccess);
    } else if (message.msgBody === "Unauthorized") {
      setMessage(message);
      authContext.setUser({ username: "", role: "" });
      authContext.setIsAuthenticated(false);
    } else {
      setMessage(message);
    }
  };

  const onSubmitRole = (e, role) => {
    createObject(e, role, ROLES);
    setVersionRoles(version.roles);
  };

  const handleRemoveRole = (role) => {
    handleRemove(role._id, ROLES);
  };

  const updateRole = (e, role) => {
    saveObject(e, role, ROLES);
    setVersionRoles(version.roles);
  };

  const onSubmitSkills = (e, skill) => {
    createObject(e, skill, SKILLS);
    setVersionSkills(version.skills);
  };

  const handleRemoveSkill = (skill) => {
    handleRemove(skill._id, SKILLS);
  };

  const updateSkill = (e, skill) => {
    saveObject(e, skill, SKILLS);
    setVersionSkills(version.skills);
  };
  const onSubmitHobbies = (e, hobby) => {
    createObject(e, { name: hobby.name }, HOBBIES);
  };

  const handleRemoveHobby = (hobby) => {
    handleRemove(hobby._id, HOBBIES);
  };

  const onSubmitLanguages = (e, language) => {
    createObject(e, { name: language.name }, LANGUAGES);
  };

  const handleRemoveLanguage = (language) => {
    handleRemove(language._id, LANGUAGES);
  };

  const updateLanguage = (e, language) => {
    saveObject(e, language, LANGUAGES);
  };

  const onSubmitEducations = (e, education) => {
    createObject(
      e,
      {
        name: education.name,
        school: education.school,
        fromDate: education.fromDate,
        toDate: education.toDate,
        ongoing: education.ongoing,
      },
      EDUCATIONS
    );
  };

  const handleRemoveEducation = (education) => {
    handleRemove(education._id, EDUCATIONS);
  };

  const updateEducation = (e, education) => {
    saveObject(e, education, EDUCATIONS);
  };

  const onSubmitExperiences = (e, experience) => {
    createObject(
      e,
      {
        name: experience.name,
        description: experience.description,
        tools: experience.tools,
        fromDate: experience.fromDate,
        toDate: experience.toDate,
        currentJob: experience.currentJob,
        role: experience.role,
      },
      EXPERIENCES
    );
  };

  const handleRemoveExperience = (experience) => {
    handleRemove(experience._id, EXPERIENCES);
  };

  const updateExperience = (e, experience) => {
    saveObject(e, experience, EXPERIENCES);
  };

  const createObject = (e, object, collectionName) => {
    e.preventDefault();
    AdminService.createNestedArrayItem(
      id,
      versionId,
      PROFILEVERSIONS,
      object,
      collectionName
    ).then((data) => {
      displayMessage(
        data.message,
        getUserFriendlyMessages(CREATED, collectionName)
      );
      updateConsultant();
    });
  };
  const handleRemove = (objectId, collectionName) => {
    if (
      authContext.user.role === "admin" ||
      authContext.user.role === "admin/user"
    ) {
      AdminService.deleteNestedArrayItem(
        id,
        versionId,
        PROFILEVERSIONS,
        objectId,
        collectionName
      ).then((data) => {
        displayMessage(
          data.message,
          getUserFriendlyMessages(REMOVED, collectionName)
        );
        updateConsultant();
      });
    }
  };
  const saveObject = (e, object, collectionName) => {
    e.preventDefault();
    AdminService.updateNestedArrayItem(
      id,
      versionId,
      PROFILEVERSIONS,
      object,
      collectionName
    ).then((data) => {
      displayMessage(
        data.message,
        getUserFriendlyMessages(UPDATED, collectionName)
      );
      updateConsultant();
    });
  };

  return (
    <>
      <div style={{ display: "flex", justifyContent: "center" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            width: "85%",
          }}
        >
          <IconButton onClick={() => history.push(`/versionmanager/${id}`)}>
            <ArrowBackIcon />
          </IconButton>
          {
            <div style={{ textAlign: "center" }}>
              {versionId === "new" && version.name === "" && (
                <h4
                  style={{ textAlign: "center", marginTop: "10px" }}
                >{`Editing version: New version - ${consultant.firstname} ${consultant.lastname}`}</h4>
              )}
              {((versionId === "new" && version.name !== "") ||
                versionId !== "new") && (
                <h4
                  style={{ textAlign: "center", marginTop: "10px" }}
                >{`Editing version: ${version.name} (${getProfileLanguageName(
                  version.language
                )}) - ${consultant.firstname} ${consultant.lastname}`}</h4>
              )}
            </div>
          }
          <div>
            <ArrowBackIcon style={{ color: "#FAFAFA" }} />
          </div>
        </div>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          marginTop: "10px",
        }}
      >
        <Paper style={{ width: !onMobile ? "85%" : "100%" }}>
          <div
            style={{
              backgroundColor: "#13222D",
              padding: "20px",
              borderTopLeftRadius: "5px",
              borderTopRightRadius: "5px",
              display: "flex",
              alignItems: "center",
              flexDirection: onMobile ? "column" : "",
            }}
          >
            <img
              alt="Profile"
              src={getProfilePictureSource(
                anonymousProfile,
                consultant.profilePic
              )}
              style={{
                objectFit: "cover",
                width: "150px",
                height: "150px",
                borderRadius: "50%",
                boxShadow: "0px 1px 16px -4px rgba(0,0,0,0.75)",
                border: " 2px solid #13222D",
                position: "relative",
                top: "0",
                left: "0",
              }}
            />
            <div
              style={{ color: "white", marginLeft: "10px", minWidth: "40%" }}
            >
              <h2>
                {consultant.firstname && !anonymousProfile
                  ? `${consultant.firstname} ${consultant.lastname}`
                  : anonymousProfile
                  ? "Anonymous"
                  : "No name..."}
              </h2>
              <h5 style={{ marginBottom: "5px" }}>{version.title}</h5>
              <div
                style={{
                  display: "flex",
                  marginTop: "10px",
                  alignItems: "center",
                }}
              >
                <EmailIcon fontSize="small" />
                <p style={{ marginBottom: "0px", marginLeft: "5px" }}>
                  {consultant.email && !anonymousProfile
                    ? consultant.email
                    : anonymousProfile && managerResume
                    ? consultant.email
                    : anonymousProfile && !managerResume
                    ? "Anonymous"
                    : `No email...`}
                  {managerResume && <span> (manager email)</span>}
                </p>
              </div>
              <div
                style={{
                  display: "flex",
                  marginTop: "10px",
                  alignItems: "center",
                }}
              >
                <PhoneIcon fontSize="small" />
                <p style={{ marginBottom: "0px", marginLeft: "5px" }}>
                  {consultant.phone && !anonymousProfile
                    ? consultant.phone
                    : anonymousProfile && managerResume
                    ? consultant.phone
                    : anonymousProfile && !managerResume
                    ? "Anonymous"
                    : `No phone...`}
                  {managerResume && <span> (manager phone)</span>}
                </p>
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <LocationCityIcon fontSize="small" />
                <p style={{ margin: "2px 5px" }}>
                  {consultant.officeLocation
                    ? consultant.officeLocation
                    : "No location..."}
                </p>
              </div>
            </div>
            <div
              style={{
                color: "white",
                display: "flex",
                justifyContent: !onMobile ? "flex-end" : "center",
                width: "100%",
                alignItems: "flex-end",
                marginTop: onMobile ? "10px" : "",
                alignSelf: "flex-end",
                justifySelf: "flex-end",
                flexWrap: "wrap",
              }}
            >
              <>
                {authContext.user.role.includes("admin") && (
                  <>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={anonymousProfile}
                          onClick={() => {
                            setAnonymousProfile(!anonymousProfile);
                          }}
                          onChange={onChange}
                          name="anonymousProfile"
                          value={anonymousProfile}
                          style={{
                            color: "white",
                            padding: "0px 10px",
                            marginTop: "-2px",
                          }}
                        />
                      }
                      label="Anonymous"
                      style={{
                        padding: "10px 2px 5px",
                        marginBottom: "0px",
                      }}
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={managerResume}
                          onClick={() => {
                            setManagerResume(!managerResume);
                          }}
                          onChange={changeManager}
                          name="managerResume"
                          value={managerResume}
                          style={{
                            color: "white",
                            padding: "0px 10px",
                            marginTop: "-2px",
                          }}
                        />
                      }
                      label="Manager"
                      style={{
                        padding: "10px 2px 5px",
                        marginBottom: "0px",
                      }}
                    />
                  </>
                )}
                {
                  <>
                    <IconButton
                      variant="outlined"
                      style={{
                        marginRight: "20px",
                        color: "white",
                        padding: "0px 0px 6px 0px",
                      }}
                      onClick={printView}
                    >
                      <PictureAsPdfIcon />
                    </IconButton>
                  </>
                }
                <IconButton
                  variant="outlined"
                  color="secondary"
                  style={{
                    marginLeft: "0px",
                    padding: "0px 0px 6px 0px",
                  }}
                  onClick={deleteVersion}
                >
                  <DeleteIcon />
                </IconButton>
              </>
            </div>
          </div>
          <div style={{ margin: "20px 0px" }}>
            <div
              style={{
                padding: "20px",
                display: "flex",
                flexDirection: onMobile ? "column" : "row",
              }}
            >
              <div
                style={{
                  width: !onMobile ? "70%" : "100%",
                  borderRight: !onMobile ? "1px solid #e1e1e1" : "",
                  paddingRight: "20px",
                }}
              >
                <form onSubmit={onSubmit} style={{ display: "flex" }}>
                  <TextField
                    type="text"
                    name="name"
                    label="Version name"
                    value={version.name}
                    onChange={onChange}
                    className="form-cotrol"
                    variant="outlined"
                    placeholder="Enter a name for this version"
                    style={{ margin: "0px 0px 10px 0px", width: "100%" }}
                  />
                  <TextField
                    type="text"
                    name="title"
                    label="Title"
                    value={version.title || ""}
                    onChange={onChange}
                    className="form-cotrol"
                    variant="outlined"
                    placeholder="Enter a title"
                    style={{ margin: "0px 0px 10px 10px", width: "100%" }}
                  />
                  <Button
                    type="submit"
                    variant="outlined"
                    color="primary"
                    style={{ margin: "0px 0px 10px 10px", width: "25%" }}
                  >
                    Update
                  </Button>
                </form>
                <div style={{ marginBottom: "60px" }}>
                  <Presentation
                    presentation={version.presentation}
                    onSubmitPresentation={onSubmitPresentation}
                    profileLanguage={version.language}
                  />
                </div>
                <Experiences
                  onMobile={onMobile}
                  onSubmitExperiences={onSubmitExperiences}
                  profileLanguage={version.language}
                  handleRemoveExperience={handleRemoveExperience}
                  updateExperience={updateExperience}
                  experiences={versionExperiences}
                />
              </div>
              <div style={{ width: !onMobile ? "40%" : "100%" }}>
                <div style={{ padding: "0px 20px" }}>
                  <Roles
                    onMobile={onMobile}
                    onSubmitRole={onSubmitRole}
                    profileLanguage={version.language}
                    roles={versionRoles}
                    handleRemoveRole={handleRemoveRole}
                    updateRole={updateRole}
                  />

                  <Skills
                    onMobile={onMobile}
                    onSubmitSkills={onSubmitSkills}
                    profileLanguage={version.language}
                    skills={versionSkills}
                    handleRemoveSkill={handleRemoveSkill}
                    updateSkill={updateSkill}
                  />
                  <Languages
                    onMobile={onMobile}
                    languages={versionLanguages}
                    onSubmitLanguages={onSubmitLanguages}
                    profileLanguage={version.language}
                    handleRemoveLanguage={handleRemoveLanguage}
                    updateLanguage={updateLanguage}
                  />
                  <Hobbies
                    onSubmitHobbies={onSubmitHobbies}
                    profileLanguage={version.language}
                    handleRemoveHobby={handleRemoveHobby}
                    hobbies={versionHobbies}
                  />
                  <Educations
                    onSubmitEducations={onSubmitEducations}
                    profileLanguage={version.language}
                    handleRemoveEducation={handleRemoveEducation}
                    educations={versionEducations}
                    updateEducation={updateEducation}
                  />
                </div>
              </div>
            </div>
          </div>

          <PrintConsultantPage
            printableId="printme"
            language={version.language}
            anonymousProfile={anonymousProfile}
            managerResume={managerResume}
            consultantEmail={consultant.email}
            consultantPhoneNo={consultant.phone}
            consultantFirstname={consultant.firstname}
            consultantLastName={consultant.lastname}
            consultantProfilePic={consultant.profilePic}
            consultantTitle={version.title}
            managerInfo={managerInfo}
            presentation={version.presentation}
            roles={versionRoles}
            skills={versionSkills}
            hobbies={versionHobbies}
            languages={versionLanguages}
            educations={versionEducations.map((item) => {
              Object.assign(item, {
                fromDateFormatted:
                  item.fromDate !== null ? item.fromDate.split("T")[0] : "",
                toDateFormatted:
                  item.toDate !== null
                    ? item.toDate.split("T")[0]
                    : "2999-12-30",
              });
              return item;
            })}
            experiences={versionExperiences.map((item) => {
              Object.assign(item, {
                fromDateFormatted:
                  item.fromDate !== null ? item.fromDate.split("T")[0] : "",
                toDateFormatted:
                  item.toDate !== null
                    ? item.toDate.split("T")[0]
                    : "2999-12-30",
              });
              return item;
            })}
          />
        </Paper>
      </div>
    </>
  );
};

export default VersionEditor;
